import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import NavbarScreen from "./components/pages/NavBar/NavbarScreen";
import AppRoute from "./components/route/AppRoute";
import { Provider } from "react-redux";
import store from "./components/redux/store";
import { ToastContainer } from "react-toastify";
import TitleManager from "./components/pages/TitleManager";
import ScrollView from "./components/pages/ScrollView";
import ScrollToTop from "./components/pages/ScrollToTop";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <TitleManager />
        <ToastContainer />
        <ScrollToTop />
        <ScrollView />
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 10,
            backgroundColor: "white",
            borderBottom: "1px solid lightgray",
          }}
        >
          <NavbarScreen />
        </div>
        <div style={{ marginTop: "65px" }}>
          <AppRoute />
        </div>
      </Router>
    </Provider>
  );
}

export default App;
